import { CLICK_OUTSIDE_IGNORE_ATTR_NAME } from './ClickOutside.constants';

export function isClickedOutside(
  clickedElement: HTMLElement,
  referenceElement: HTMLElement,
  targetElement: HTMLElement | HTMLElement[]
): boolean {
  let clickedEl = clickedElement;

  while (clickedEl) {
    if (
      clickedEl === referenceElement ||
      (clickedEl.getAttribute && clickedEl.getAttribute(CLICK_OUTSIDE_IGNORE_ATTR_NAME) === 'true')
    ) {
      return false;
    }
    clickedEl = clickedEl.parentNode as HTMLElement;
  }

  let isTargetClick = false;
  if (Array.isArray(targetElement)) {
    isTargetClick = targetElement.filter(Boolean).some((el) => el.contains(clickedElement));
  } else {
    isTargetClick = targetElement ? targetElement.contains(clickedElement) : false;
  }

  return !referenceElement.contains(clickedElement) && !isTargetClick;
}
